import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  signupData: null,
  loading: false, 
 token: localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token")) : null, 
  onBoarding: localStorage.getItem("onBoarding") ? JSON.parse(localStorage.getItem("onBoarding")) : null, 
};

const AuthSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setSignupData(state, value) {
      state.signupData = value.payload;
    },
    setLoading(state, value) {
      state.loading = value.payload;
    },
    setToken(state, value) {
      state.token = value.payload;
    },
    setOnBoarding(state, value) {
      state.onBoarding= value.payload;
    },
  },
});

export const { setSignupData, setLoading, setToken ,setOnBoarding} = AuthSlice.actions;

export default AuthSlice.reducer;